"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeReading = exports.encodeReading = exports.encodeReadings = exports.encodeDataType = exports.decodeDataType = exports.encodeClassifier = exports.decodeClassifier = exports.encodeResourceId = exports.decodeResourceId = void 0;
const types_1 = require("../types");
const string_1 = require("./string");
function decodeResourceId(dataView) {
    let withoutHyphens = "";
    for (let i = 0; i < 4; i++) {
        withoutHyphens += (0, string_1.padStart)(dataView.getUint32(1 + i * 4).toString(16), 8, "0");
    }
    return [
        withoutHyphens.substring(0, 8),
        withoutHyphens.substring(8, 12),
        withoutHyphens.substring(12, 16),
        withoutHyphens.substring(16, 20),
        withoutHyphens.substring(20, 32),
    ].join("-");
}
exports.decodeResourceId = decodeResourceId;
function encodeResourceId(dataView, resourceId) {
    const withoutHyphens = resourceId.replace(/-/g, "");
    for (let i = 0; i < 4; i++) {
        dataView.setUint32(1 + i * 4, parseInt(withoutHyphens.substring(i * 8, (i + 1) * 8), 16));
    }
}
exports.encodeResourceId = encodeResourceId;
function decodeClassifier(dataView) {
    return types_1.Classifier.decode(dataView.getUint8(17));
}
exports.decodeClassifier = decodeClassifier;
function encodeClassifier(dataView, classifier) {
    dataView.setUint8(17, types_1.Classifier.encode(classifier));
}
exports.encodeClassifier = encodeClassifier;
function decodeDataType(dataView) {
    const dataTypeIndex = dataView.getUint8(27);
    return types_1.DataType.fromKey(dataTypeIndex);
}
exports.decodeDataType = decodeDataType;
function encodeDataType(dataView, dataType) {
    const dataTypeIndex = dataType.key;
    if (dataTypeIndex < 0) {
        throw new Error("Data type not found");
    }
    dataView.setUint8(27, dataTypeIndex);
}
exports.encodeDataType = encodeDataType;
function encodeReadings(dataView, dataType, data) {
    // Copy the resource data into the new buffer. We have to use DataView in case receiving machine has different endianess
    for (const [index, value] of data.entries()) {
        encodeReading(dataView, dataType, index, value);
    }
}
exports.encodeReadings = encodeReadings;
function encodeReading(dataView, dataType, index, value) {
    index *= dataType.bytes;
    value = value !== null && value !== void 0 ? value : dataType.nullValue;
    switch (dataType.key) {
        case 0 /* DataTypeKey.UInt8 */:
            return dataView.setUint8(index, value);
        case 1 /* DataTypeKey.Int8 */:
            return dataView.setInt8(index, value);
        case 2 /* DataTypeKey.UInt16 */:
            return dataView.setUint16(index, value);
        case 3 /* DataTypeKey.Int16 */:
            return dataView.setInt16(index, value);
        case 4 /* DataTypeKey.UInt32 */:
            return dataView.setUint32(index, value);
        case 5 /* DataTypeKey.Int32 */:
            return dataView.setInt32(index, value);
        case 6 /* DataTypeKey.UInt64 */:
            throw new Error("UInt64 is not supported");
        case 7 /* DataTypeKey.Int64 */:
            throw new Error("Int64 is not supported");
        case 8 /* DataTypeKey.Float32 */:
            return dataView.setFloat32(index, value);
        case 9 /* DataTypeKey.Float64 */:
            return dataView.setFloat64(index, value);
    }
}
exports.encodeReading = encodeReading;
function decodeReading(dataView, dataType, index) {
    index *= dataType.bytes;
    let decoded;
    switch (dataType.key) {
        case 0 /* DataTypeKey.UInt8 */:
            decoded = dataView.getUint8(index);
            break;
        case 1 /* DataTypeKey.Int8 */:
            decoded = dataView.getInt8(index);
            break;
        case 2 /* DataTypeKey.UInt16 */:
            decoded = dataView.getUint16(index);
            break;
        case 3 /* DataTypeKey.Int16 */:
            decoded = dataView.getInt16(index);
            break;
        case 4 /* DataTypeKey.UInt32 */:
            decoded = dataView.getUint32(index);
            break;
        case 5 /* DataTypeKey.Int32 */:
            decoded = dataView.getInt32(index);
            break;
        case 6 /* DataTypeKey.UInt64 */:
            throw new Error("UInt64 is not supported");
        case 7 /* DataTypeKey.Int64 */:
            throw new Error("Int64 is not supported");
        case 8 /* DataTypeKey.Float32 */:
            decoded = dataView.getFloat32(index);
            break;
        case 9 /* DataTypeKey.Float64 */:
            decoded = dataView.getFloat64(index);
            break;
    }
    if (decoded === dataType.nullValue || isNaN(decoded)) {
        return null;
    }
    return decoded;
}
exports.decodeReading = decodeReading;
//# sourceMappingURL=binary.js.map